import { ITabelaPrecoSegmentacao } from 'app/domains/preparation/tabelas-precos/interfaces/tabela-preco-segmentacao.interface';
import { BaseEntity } from '../../models';
import { moedaReal } from '../common/moeda';
import { tabelaPrecoAtiva } from './tabela-preco-situacao';
import { TabelaPrecoRevisao } from './revisoes';
import { TabelaPrecoLinha } from './linha';
import { TabelaPrecoRepresentante } from './representante';
import { LocalFaturamento } from '../local-faturamento';

export class TabelaPreco implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    codigo: number;
    nome: string;
    situacao: number;
    exportacao: boolean;
    moeda: number;
    idLocalFaturamento: number;
    localFaturamento: LocalFaturamento;
    bloquearEdicaoLocalFaturamento: boolean;

    // Revisões
    revisaoVigente: TabelaPrecoRevisao;
    revisoes: TabelaPrecoRevisao[];

    // Acessos
    somenteCampanha: boolean;
    representantes: TabelaPrecoRepresentante[];
    segmentacoes: ITabelaPrecoSegmentacao[];

    // Integração ERP
    codigoIntegracaoErp: string;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    /** LEGADO **/
    linhas: TabelaPrecoLinha[];

    constructor() {
        this.situacao = tabelaPrecoAtiva.id;
        this.linhas = [];
        this.representantes = [];
        this.segmentacoes = [];
        this.moeda = moedaReal.id;
        this.exportacao = false;
    }
}
